import { Component, OnInit, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService, AlertService } from 'src/app/services';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

declare var jQuery: any,Highcharts:any, moment:any, $:any;
import 'datatables.net';
import 'datatables.net-bs4';

@Component({
  selector: 'app-graph-report',
  templateUrl: './graph-report.component.html',
  styleUrls: ['./graph-report.component.css']
})
export class GraphReportComponent implements OnInit {

  dataTable :any;
    permissionData:any=[];
    clientCode : any = '';
    clientId: any = "";
    userId: any = "";
    customerId:any = "";
    tierId:any = "";
    graphRenderData = []
    assetDatalist:any = [];
    dropdownSettingsAsset = {
        singleSelection: false,
        idField: 'assetId',
        textField: 'name',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 0,
        allowSearchFilter: true
    };

    selectedAsset:any = [];
    TierList:any = []

    widthBarGraph = 600;
    heightBarGraph = 400;
    typeBarGraph = "stackedbar2d";
    dataFormatBarGraph = "json";
    dataSourceBarGraph:any = {};

    chartObjBar:any;
    handler: any;


    widthCol = 600;
    heightCol = 400;
    typeCol = "stackedcolumn2d";
    dataFormatCol = "json";
    dataSourceCol = {};

    chart: am4charts.XYChart;
    datapointChart: am4charts.XYChart;
    rangeValueRuntime: { from: Date; to: Date } = {
        from: new Date(),
        to: (new Date() as any)['fp_incr'](30)
      };

  
    
    constructor(private router: Router, private route: ActivatedRoute, private apiService: ApiService, private alertService: AlertService, private zone: NgZone) {
        this.permissionData = ApiService.permission;
        this.clientId = localStorage.getItem("clientId");
        this.userId = localStorage.getItem("userId");
        this.customerId =(localStorage.getItem("customerId")?JSON.parse(localStorage.getItem("customerId")):[]);
        this.tierId =(localStorage.getItem("tierId")?JSON.parse(localStorage.getItem("tierId")):[]);

    }

    ngOnInit() {
        this.clientCode = this.alertService.getClientCode();
        
        // this.getRuntimeGraphData()

        this.dataSourceBarGraph = {
          chart: {
            caption: "Correlation coefficuent between datapoint and downtime",
            placevaluesinside: "1",
            showvalues: "0",
            usePlotGradientColor:0,
            plottooltext: "<b>$dataValue</b>  $seriesName ",
            theme: "fusion"
          },
          categories: [
            {
              category: [
                {
                  label: "Pump"
                },
                {
                  label: "Motor"
                },
                {
                  label: "Compressor"
                },
                {
                  label: "Generator"
                },
                {
                  label: "Boiler"
                }
              ]
            }
          ],
          dataset: [
            {
              seriesname: "Series1",
              data: [
                {
                  value: "17000"
                },
                {
                  value: "19500"
                },
                {
                  value: "12500"
                },
                {
                  value: "14500"
                },
                {
                  value: "17500"
                }
              ]
            },
            {
              seriesname: "Series2",
              data: [
                {
                  value: "2500"
                },
                {
                  value: "2800"
                },
                {
                  value: "2800"
                },
                {
                  value: "1950"
                },
                {
                  value: "1200"
                }
              ]
            },
            {
              seriesname: "Series3",
              data: [
                {
                  value: "254"
                },
                {
                  value: "298"
                },
                {
                  value: "218"
                },
                {
                  value: "195"
                },
                {
                  value: "212"
                }
              ]
            }
          ]
        };

        this.dataSourceCol =  {
          chart: {
            caption: "test",
            subcaption: " --",
            numbersuffix: "",
            showsum: "1",
            plottooltext:
              "$label  <b>$dataValue</b> of  $seriesName",
            theme: "fusion",
            drawcrossline: "1"
          },
          categories: [
            {
              category: [
                {
                  label: "Label 1"
                },
                {
                  label: "Label 2"
                },
                {
                  label: "Label 3"
                },
                {
                  label: "Label 4"
                },
                {
                  label: "Label 5"
                },
                {
                  label: "Label 6"
                }
              ]
            }
          ],
          dataset: [
            {
              seriesname: "S1",
              data: [
                {
                  value: "400"
                },
                {
                  value: "830"
                },
                {
                  value: "500"
                },
                {
                  value: "420"
                },
                {
                  value: "790"
                },
                {
                  value: "380"
                }
              ]
            },
            {
              seriesname: "S2",
              data: [
                {
                  value: "350"
                },
                {
                  value: "620"
                },
                {
                  value: "410"
                },
                {
                  value: "370"
                },
                {
                  value: "720"
                },
                {
                  value: "310"
                }
              ]
            }
          ]
        };
        setTimeout(() => {
          this.handler = this.clickChartBar.bind(this);
          // this.message = this.clickPlotMsg;
          // this.attached = true;
          this.chartObjBar.addEventListener('dataplotClick', this.handler);
        }, 1000);
    }

    clickChartBar(event){
      console.log(event);
      
    }

    initializedChartBar($event) {
      this.chartObjBar = $event.chart;
    }

    
    onItemSelectAsset(event){

    }


    onItemDeselectAsset(event){

    }

    onSelectAllAsset(event){

    }

    onDeSelectAllAsset(){

    }

    // Getting Asset List
    getAllAssetList() {

        if ($.fn.DataTable.isDataTable('#asset_data_table_tab')) {
            $('#asset_data_table_tab').DataTable().destroy();
        };
        // if ($.fn.DataTable.isDataTable('#asset_data_table_runtime')) {
        //     $('#asset_data_table_runtime').DataTable().destroy();
        // };
        var URL = 'asset/getAssetByClient';
        let apiData: any = {
          clientId: this.clientId,
          userId: this.userId,
          // isAssetLive: true,
        }
        if (this.customerId != null && this.customerId != '') {
          apiData.customerIds = this.customerId.toString();
            // var customerString = '&customerId=' + this.customerId.toString();
            // var URL = URL.concat(customerString);
        }
        if (this.tierId != null && this.tierId != '') {
          apiData.tierIds = this.tierId.toString();
            // var tierString = '&tierId=' + this.tierId.toString();
            // var URL = URL.concat(tierString);
        }

        this.apiService.create(URL, apiData).subscribe(
            data => {
                // if ($.fn.DataTable.isDataTable('#asset_data_table_assettab')) {
                //     $('#asset_data_table_assettab').DataTable().destroy();
                // };
                if (data.statusCode == 100) {
                    // this.assetDatalist = data.responseList;
                    this.assetDatalist = [
                      {
                        "assetId": 15133,
                        "description": "1xAltronic-NTV,IDP680#01053640SKY7125",
                        "name": "# Crow(71)",
                        "assetName": "# Crow(71)",
                        "assetDescription": "1xAltronic-NTV,IDP680",
                        "alarmState": "No comm",
                        "gmtOffset": -6,
                        "siteName": "Azores Fed 6H EF6103",
                        "tierName": "Area 7",
                        "customerName": "vindesh222",
                        "generatedTicker": 2,
                        "technician": 2,
                        "smsEvent": 2,
                        "emailEvent": 2,
                        "warningEvent": 2,
                        "alarmEvent": 2,
                        "normalEvent": 2,
                        
                      },
                      {
                        "assetId": 21268,
                        "description": "1xCenturionC4,IDP680#01298480SKYBF2D",
                        "name": "Admiral Fed Com 2H MC6029",
                        "assetName": "Admiral Fed Com 2H MC6029",
                        "assetDescription": "1xCenturionC4,IDP680",
                        "alarmState": "No comm",
                        "gmtOffset": -7,
                        "siteName": "AmciSite11",
                        "tierName": "AmciTestTier",
                        "customerName": "pooja patidar",
                        "generatedTicker": 2,
                        "technician": 1,
                        "smsEvent": 2,
                        "emailEvent": 3,
                        "warningEvent": 5,
                        "alarmEvent": 1,
                        "normalEvent": 2,                        
                      },
                      {
                        "assetId": 21512,
                        "description": "1xDE3000,IDP680#01323525SKY7C56",
                        "name": "Antietam CTB EF6073",
                        "assetName": "Antietam CTB EF6073",
                        "assetDescription": "1xDE3000,IDP680",
                        "alarmState": "No comm",
                        "gmtOffset": -7,
                        "siteName": "Antietam CTB EF6073",
                        "tierName": "Area 7",
                        "customerName": "Harsh",
                        "generatedTicker": 5,
                        "technician": 2,
                        "smsEvent": 6,
                        "emailEvent": 6,
                        "warningEvent": 9,
                        "alarmEvent": 6,
                        "normalEvent": 5,
                      },
                      {
                        "assetId": 24614,
                        "description": "EMIT-Annunciator,ST6100#01457306SKY853F",
                        "name": "Antietam CTB EF6074",
                        "assetName": "Antietam CTB EF6074",
                        "assetDescription": "EMIT-Annunciator,ST6100",
                        "alarmState": "No comm",
                        "gmtOffset": -6,
                        "siteName": "Antietam CTB EF6073",
                        "tierName": "Area 7",
                        "customerName": "AmciCustomer",
                        "generatedTicker": 31,
                        "technician": 12,
                        "smsEvent": 32,
                        "emailEvent": 4,
                        "warningEvent": 0,
                        "alarmEvent": 2,
                        "normalEvent": 5,
                      },
                      {
                        "assetId": 21791,
                        "description": "1xTTD,IDP680#01318623SKY8498",
                        "name": "Arch Benge C1 2404BH EF6089",
                        "assetName": "Arch Benge C1 2404BH EF6089",
                        "assetDescription": "1xTTD,IDP680",
                        "alarmState": "No comm",
                        "gmtOffset": -6,
                        "siteName": "Arch Benge C1 2404BH EF6089",
                        "tierName": "Texas",
                        "customerName": "Concho",
                        "generatedTicker": 3,
                        "technician": 2,
                        "smsEvent": 3,
                        "emailEvent": 6,
                        "warningEvent": 3,
                        "alarmEvent": 6,
                        "normalEvent": 6,                        
                      }
                    ];
                } else {
                    // this.assetDatalist    = [];
                }
                

                // $('#asset_data_table_assettab').DataTable();
                setTimeout(() => {
                  const table: any = $('#asset_data_table_tab');
                      this.dataTable = table.DataTable({
                        "order": [],
                        "bDestroy": true,
                        "destroy":true,
                        // "columnDefs": [{ "orderable": false, "targets": 9 },{ "orderable": false, "targets": 0 },{ "orderable": false, "targets": 10 }],
                    });  
                }, 1000);
                
                //     const table2: any = $('#asset_data_table_runtime');
                //     table.DataTable({
                //         "order": [],
                //         "bDestroy": true,
                //         "destroy":true,
                //         // "columnDefs": [{ "orderable": false, "targets": 9 },{ "orderable": false, "targets": 0 },{ "orderable": false, "targets": 10 }],
                //     });
                this.selectedAsset = [];

            },
            error =>{
              this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
             }
        );
    }

    getTotal(val){
      let total = 0
      this.assetDatalist.map((obj,index)=>{
        total+=obj[val]
      })
      return total;
    }

    getAllTier(){
      var URL = 'tier/getAllTierByUser?clientId=' + this.clientId + '&userId=' + this.userId;
      /*if (this.customerId != null && this.customerId != '') {
          var customerString = '&customerId=' + this.customerId.toString();
          var URL = URL.concat(customerString);
      }*/
      this.apiService.getAll(URL).subscribe(
          data => {
              if (data.statusCode == 100) {
                  this.TierList = data.responseList ? data.responseList : [];
                  
              } else {
                
              }
          },
          error => {
              // this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
          }
          );
    }



    ngAfterViewInit() {
        // -----------------------------------------------------------------------------------------  amchart bar graph 
        this.createSeriesChart()
      this.createMonthChart();
        
        this.craeteColumnBar()
        this.getAllAssetList();
        this.getAllTier()
        this.getChartData()
    }

    createMonthChart(){
      // Create chart instance
      let chart2 = am4core.create("chartdivBarGraph", am4charts.XYChart);
      chart2.scrollbarX = new am4core.Scrollbar()

      chart2.data = [{
        "month": "January",
        available:54,
        "value": 3025
      }, {
        "month": "February",
        available:96,
        "value": 1882
      }, {
        "month": "March",
        available:78,
        "value": 1809
      }, {
        "month": "April",
        available:68,
        "value": 1322
      }, {
        "month": "May",
        available:89,
        "value": 1122
      }, {
        "month": "Jun",
        available:79,
        "value": 1114
      }, {
        "month": "July",
        available:99,
        "value": 984
      }, {
        "month": "August",
        available:89,
        "value": 711
      }, {
        "month": "September",
        available:78,
        "value": 665
      }, {
        "month": "October",
        available:100,
        "value": 1105
      }, {
        "month": "November",
        available:93,
        "value": 765
      }, {
        "month": "December",
        available:98,
        "value": 855
      }];

      for(var i = 0; i < chart2.data.length; i++){
          let value = Math.floor(Math.random() * 100); //chart2.data[i].visits;
          chart2.data[i].available = value
          // total += value;
      }

      // prepareParetoData();

      // function prepareParetoData(){
      //     let total = 0;

      //     for(var i = 0; i < chart2.data.length; i++){
      //         let value = chart2.data[i].visits;
      //         total += value;
      //     }

      //     let sum = 0;
      //     for(var i = 0; i < chart2.data.length; i++){
      //         let value = chart2.data[i].visits;
      //         sum += value;   
      //         chart2.data[i].pareto = sum / total * 100;
      //     }    
      // }

      // Create axes
      let categoryAxis = chart2.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "month";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 60;
      categoryAxis.tooltip.disabled = true;

      let valueAxis = chart2.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.minWidth = 50;
      valueAxis.min = 0;
      valueAxis.cursorTooltipEnabled = false;

      // Create series
      let series = chart2.series.push(new am4charts.ColumnSeries());
      series.sequencedInterpolation = true;
      series.dataFields.valueY = "value";
      series.name = "Assets";
      series.dataFields.categoryX = "month";
      series.tooltipText = "{categoryX} : {valueY}[/]";
      series.columns.template.strokeWidth = 0;
      series.propertyFields.fill = "red";
      // series.fill = am4core.color("red").lighten(0.5);
      // series.stroke = am4core.color("red").lighten(0.5);

      // series.columns.template.fill = am4core.color("#00ff00");
      
      series.tooltip.pointerOrientation = "vertical";

      series.columns.template.column.cornerRadiusTopLeft = 10;
      series.columns.template.column.cornerRadiusTopRight = 10;
      series.columns.template.column.fillOpacity = 0.8;
      series.columns.template.column.fill = am4core.color("#66b7dc");;

      // on hover, make corner radiuses bigger
      let hoverState = series.columns.template.column.states.create("hover");
      hoverState.properties.cornerRadiusTopLeft = 0;
      hoverState.properties.cornerRadiusTopRight = 0;
      hoverState.properties.fillOpacity = 1;

      series.columns.template.adapter.add("fill", function(fill, target) {
        return chart2.colors.getIndex(target.dataItem.index);
      })


      let paretoValueAxis = chart2.yAxes.push(new am4charts.ValueAxis());
      paretoValueAxis.renderer.opposite = true;
      paretoValueAxis.min = 0;
      paretoValueAxis.max = 100;
      paretoValueAxis.strictMinMax = true;
      paretoValueAxis.renderer.grid.template.disabled = true;
      paretoValueAxis.numberFormatter = new am4core.NumberFormatter();
      paretoValueAxis.numberFormatter.numberFormat = "#'%'"
      paretoValueAxis.cursorTooltipEnabled = false;

      let paretoSeries = chart2.series.push(new am4charts.LineSeries())
      paretoSeries.dataFields.valueY = "available";
      paretoSeries.name = "Availability (%)";
      paretoSeries.dataFields.categoryX = "month";
      paretoSeries.yAxis = paretoValueAxis;
      paretoSeries.tooltipText = "Availability: {valueY.formatNumber('#.0')}%[/]";
      paretoSeries.tooltip.background.fill = am4core.color("#ff0000");
      paretoSeries.tooltip.fillOpacity = 0.7//am4core.color("#ff0000");
      let lineseries = new am4charts.CircleBullet()
      lineseries.fill = am4core.color("#ff0000");
      paretoSeries.bullets.push(lineseries);
      // paretoSeries.stroke = new am4core.InterfaceColorSet().getFor("alternativeBackground");
      paretoSeries.strokeWidth = 3; // 3px
      paretoSeries.stroke = am4core.color("#ff0000"); // red
      // paretoSeries.strokeOpacity = 0.5;
      // paretoSeries.template.stroke = am4core.color("#ff0000"); // red outline
      paretoSeries.tooltip.fill = am4core.color("#00ff00"); // green fill

      // Cursor
      chart2.cursor = new am4charts.XYCursor();
      chart2.cursor.behavior = "panX";
      chart2.scrollbarX.parent = chart2.bottomAxesContainer;
      chart2.legend = new am4charts.Legend();

    }

    createSeriesChart(){
      this.zone.runOutsideAngular(() => {
            
        let chart = am4core.create("chartdiv", am4charts.XYChart);

        chart.paddingRight = 20;

        let data = [];
        let visits = 10;
        let visits2 = 10;
        let notification = 10;
        let asset = 10;

        var startDate =  moment(this.rangeValueRuntime.from)//moment(new Date('1/1/2014'));
        var endDate   = moment(this.rangeValueRuntime.to)//moment(new Date('6/1/2014'));
        console.log(startDate.toDate(), endDate.toDate());
        // startDate = startDate.add(1, 'days');
        let diff = moment(endDate.toDate()).diff(startDate.toDate(),'days')
        // console.log(startDate.format('M/D/YYYY') , endDate.format('M/D/YYYY'),diff);
        
    
        while(moment(endDate.toDate()).format('M/D/YYYY') !=  moment(startDate.toDate()).format('M/D/YYYY')) {
          // console.log(startDate.toDate(),moment(endDate.toDate()).diff(startDate.toDate(),'days'));
        //   // dates.push(startDate.toDate());
        
        visits = (visits/2)
        visits2 = (visits2/2)
        notification = (notification/2)
        asset = (asset/2)
        
        visits += Math.round((Math.random() /* < 0.5 ? 1 : 10 */) * Math.random() * 10);
        visits2 += Math.round((Math.random() /* < 0.5 ? 1 : 10 */) * Math.random() * 50);
        notification += Math.round((Math.random() /* < 0.5 ? 1 : 10 */) * Math.random() * 50);
        asset += Math.round(Math.round((Math.random() /* < 0.5 ? 1 : 10 */) * Math.random() * 10));
        data.push({ date: new Date(startDate.toDate()),  event: visits, maintenance: visits2, notification:notification, asset:asset });
        startDate = startDate.add(1, 'days');
        }


        // for (let i = 1; i < 366; i++) {

        //     visits = (visits/2)
        //     visits2 = (visits2/2)
        //     notification = (notification/2)

        //     visits += Math.round((Math.random() /* < 0.5 ? 1 : 10 */) * Math.random() * 10);
        //     visits2 += Math.round((Math.random() /* < 0.5 ? 1 : 10 */) * Math.random() * 50);
        //     notification += Math.round((Math.random() /* < 0.5 ? 1 : 10 */) * Math.random() * 50);
        //     data.push({ date: new Date(2018, 0, i),  event: visits, maintenance: visits2, notification:notification });
        // }

        chart.data = data;

        console.log(data);
        

        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.title.text = "";
        valueAxis.renderer.minWidth = 35;

        let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis2.tooltip.disabled = false;
        valueAxis2.renderer.minWidth = 35;
        valueAxis2.title.text = "";
        valueAxis2.cursorTooltipEnabled = false;
        // valueAxis.title.rotation = 30;
        valueAxis2.title.rotation = 270;
        valueAxis.title.align = "center";
        // valueAxis2.title.align = "center";
        // valueAxis2.title.valign = "left";
        // valueAxis2.title.dy = -40;

        // valueAxis2.renderer.line.disabled = true;
        // valueAxis2.renderer.labels.template.disabled = true;
        valueAxis2.renderer.opposite = true;
        valueAxis2.renderer.grid.template.disabled = true;
        valueAxis2.renderer.line.strokeOpacity = 1;
        valueAxis.renderer.line.strokeOpacity = 1;


         // Create series
         let columnSeries = chart.series.push(new am4charts.ColumnSeries());
         columnSeries.dataFields.valueY = "asset";
         columnSeries.dataFields.dateX = "date";
         columnSeries.yAxis = valueAxis;
         columnSeries.tooltipText = "{valueY} Asset";
         columnSeries.name = "Asset";
         columnSeries.columns.template.fillOpacity = 0.7;
         let ColState = columnSeries.columns.template.states.create("hover");
         ColState.properties.fillOpacity = 0.9;
        //  columnSeries.columns.template.propertyFields.strokeDasharray = "dashLength";
        //  columnSeries.columns.template.propertyFields.fillOpacity = "alpha";
        columnSeries.columns.template.events.on("hit", function(ev) {
          console.log("clicked on ", ev.target.dataItem.categories.categoryY);
          console.log(ev.target.dataItem.dataContext);
          self.createPopupGraph(ev.target.dataItem.dataContext)
        }, this);


// -----------------------------------------Event Series

        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.dateX = "date";
        series.dataFields.valueY = "event";
        series.name = "Event";
        series.strokeWidth = 2;
        series.tensionX = 0.7;
        series.strokeWidth = 2;
        series.fillOpacity = 0;//.5
        series.connect = false;
        series.stacked = false;
        // series.fill = am4core.color("red").lighten(0.5);
        series.stroke = am4core.color("red").lighten(0.5);
        // series.propertyFields.fill = "red";
        // series.propertyFields.stroke = "red";
        series.tooltipText = "Event : {valueY.value}";
        
        let durationBullet = series.bullets.push(new am4charts.Bullet());
        let durationRectangle = durationBullet.createChild(am4core.Rectangle);
        durationBullet.horizontalCenter = "middle";
        durationBullet.verticalCenter = "middle";
        durationBullet.width = 5;
        durationBullet.height = 5;
        durationRectangle.width = 5;
        durationRectangle.height = 5;
        let self = this
        series.events.on("hit", function(ev) {
          console.log("clicked on ", ev.target.dataItem.categories.categoryY);
          console.log(ev.target.dataItem.dataContext);
          self.createPopupGraph(ev.target.dataItem)
        }, this);
        let durationState = durationBullet.states.create("hover");
        durationState.properties.scale = 1.2;

        // --------------------------------------- Maintenance series
        let series2 = chart.series.push(new am4charts.LineSeries());//StepLineSeries
        series2.dataFields.dateX = "date";
        series2.dataFields.valueY = "maintenance";
        series2.name = "Maintenance";
        // series2.fill = am4core.color("blue").lighten(0.5);
        series2.strokeWidth = 2;
        series2.tensionX = 0.7;
        series2.fillOpacity = 0//.5;
        // series2.bullets.push(new am4charts.CircleBullet());
        series2.stroke = am4core.color("green").lighten(0.5);
        // series2.propertyFields.fill = "blue";
        // series2.propertyFields.stroke = "blue";
        series2.yAxis = valueAxis2;
        series2.tooltipText = "Maintenance :{valueY.value}";
        let pointRef= series2.bullets.push(new am4charts.Bullet());
        
        let TriangleBullet = pointRef.createChild(am4core.Triangle);
        TriangleBullet.horizontalCenter = "middle";
        TriangleBullet.verticalCenter = "middle";
        TriangleBullet.width = 5;
        TriangleBullet.height = 5;
        pointRef.width = 5;
        pointRef.height = 5;
        
       
        // --------------------------------------- notification series
        let notificationseries = chart.series.push(new am4charts.LineSeries());//StepLineSeries
        notificationseries.dataFields.dateX = "date";
        notificationseries.dataFields.valueY = "notification";
        notificationseries.name = "Notification";
        // notificationseries.fill = am4core.color("blue").lighten(0.5);
        notificationseries.strokeWidth = 2;
        notificationseries.tensionX = 0.7;
        notificationseries.fillOpacity = 0// 0.5;
        notificationseries.stroke = am4core.color("blue").lighten(0.5);
        // notificationseries.propertyFields.fill = "blue";
        // notificationseries.propertyFields.stroke = "blue";
        notificationseries.yAxis = valueAxis2;
        notificationseries.tooltipText = "Notification :{valueY.value}";

        // notificationseries.bullets.push(new am4charts.CircleBullet());
        let notificationBullet = notificationseries.bullets.push(new am4charts.Bullet());
        let notificationRectangle = notificationBullet.createChild(am4core.Circle);
        notificationRectangle.horizontalCenter = "middle";
        notificationRectangle.verticalCenter = "middle";
        notificationRectangle.width = 5;
        notificationRectangle.height = 5;
        notificationRectangle.width = 5;
        notificationRectangle.height = 5;

        chart.cursor = new am4charts.XYCursor();
        
        chart.invalidateData();
        
        chart.legend = new am4charts.Legend();
        chart.legend.position = "bottom";
        

        let scrollbarX = new am4charts.XYChartScrollbar();
        scrollbarX.series.push(series);
        scrollbarX.series.push(series2);
        scrollbarX.series.push(notificationseries);
        
        chart.scrollbarX = scrollbarX;
        chart.scrollbarX.parent = chart.bottomAxesContainer;

        this.chart = chart;
        
        // let chart = am4core.create("chartdiv", am4charts.XYChart);

        // // ... chart code goes here ...

        // this.chart = chart;
    });
    }




    craeteColumnBar(){
      let chart = am4core.create("chartdivBarGraphVertical", am4charts.XYChart);
      let self = this;
      // Add data
      chart.data = [
        {
          "pointName": "Pump",
          "value": 230,
          "warning": 250,
          alarm:12,
          fault:32
        },
        {
          "pointName": "Motor",
          "value": 102,
          "warning": 42,
          alarm:25,
          fault:53
        },
        {
          "pointName": "Compressor",
          "value": 96,
          "warning": 43,
          alarm:21,
          fault:51
        },
        {
          "pointName": "Generator",
          "value": 65,
          "warning": 45,
          alarm:54,
          fault:321
        },
        {
          "pointName": "Valve",
          "value": 85.5,
          "warning": 35,
          alarm:51,
          fault:90
        },
        {
          "pointName": "Power",
          "value": 440,
          "warning": 270,
          alarm:40,
          fault:60
        },
        {
          "pointName": "Turbine",
          "value": 262.5,
          "warning": 20,
          alarm:10,
          fault:50
        },
        {
          "pointName": "Boiler",
          "value": 96.5,
          "warning": 30,
          alarm:50,
          fault:70
        }];

      // Create axes
      let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "pointName";
      categoryAxis.numberFormatter.numberFormat = "#";
      categoryAxis.renderer.inversed = true;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.cellStartLocation = 0.1;
      categoryAxis.renderer.cellEndLocation = 0.9;

      let  valueAxis = chart.xAxes.push(new am4charts.ValueAxis()); 
      valueAxis.renderer.opposite = true;

      // Create series


      function createSeries(field, name, color) {
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueX = field;
        series.dataFields.categoryY = "pointName";
        series.stacked = true;
        series.name = name;
        series.columns.template.tooltipText = "{pointName} : {name}: [bold]{valueX}[/]";

        series.columns.template.fill = am4core.color(color);
        series.columns.template.fillOpacity = 0.9
        
        let labelBullet = series.bullets.push(new am4charts.LabelBullet());
        labelBullet.locationX = 0.5;
        labelBullet.label.text = "{valueX}";
        labelBullet.label.fill = am4core.color("#fff");
        series.columns.template.events.on("hit", function(ev) {
          console.log("clicked on ", ev.target.dataItem.categories.categoryY);
          console.log(ev.target.dataItem.dataContext);
          self.createSeriesChart();
          self.createMonthChart();
        }, this);
      }
      chart.legend = new am4charts.Legend();
      chart.legend.position = "bottom";
      /* 
      function createSeries(field, name) {
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueX = field;
        series.dataFields.categoryY = "pointName";
        series.name = name;
        series.columns.template.tooltipText = "{pointName}: [bold]{valueX}[/]";
        series.columns.template.height = am4core.percent(100);
        series.sequencedInterpolation = true;

        let valueLabel = series.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.text = "{valueX}";
        valueLabel.label.horizontalCenter = "left";
        valueLabel.label.dx = 10;
        valueLabel.label.hideOversized = false;
        valueLabel.label.truncate = false;

        // let categoryLabel = series.bullets.push(new am4charts.LabelBullet());
        // categoryLabel.label.text = "{name}";
        // categoryLabel.label.horizontalCenter = "right";
        // categoryLabel.label.dx = -10;
        // categoryLabel.label.fill = am4core.color("#fff");
        // categoryLabel.label.hideOversized = false;
        // categoryLabel.label.truncate = false;
      } */

      createSeries("value", "Normal",'green');
      createSeries("warning", "Warning",'#ffc14e');
      createSeries("alarm", "Alarm",'#ff6d6d');
      createSeries("fault", "Fault","#ab3232");
      // createSeries("warning", "Warning",'orange');
      // createSeries("alarm", "Alarm",'yellow');
      // createSeries("fault", "Fault","red");
      // createSeries("expenses", "Expenses");
    }

    createPopupGraph(dataItem){
      // console.log(dataItem,"=========================");
      this.getAssetDatapoint()
    }


    getAssetDatapoint(){

      if (this.datapointChart) {
        this.datapointChart.dispose();
      }

      $("#graphModal").modal('show');

      let datapointChart = am4core.create("chart-container-datapoint", am4charts.XYChart);
      datapointChart.colors.step = 2;
      // Add data
      datapointChart.data = generateChartData();

      // Create axes
      let dateAxis = datapointChart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.minGridDistance = 50;

      // Create series
      function createAxisAndSeries(field, name, opposite, bullet) {
        let valueAxis = datapointChart.yAxes.push(new am4charts.ValueAxis());
        
        let series = datapointChart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = field;
        series.dataFields.dateX = "date";
        series.strokeWidth = 2;
        series.yAxis = valueAxis;
        series.name = name;
        series.tooltipText = "{name}: [bold]{valueY}[/]";
        series.tensionX = 0.8;
        
        let interfaceColors = new am4core.InterfaceColorSet();
        
        switch(bullet) {
          case "triangle":
            let bullet1 = series.bullets.push(new am4charts.Bullet());
            bullet1.width = 12;
            bullet1.height = 12;
            bullet1.horizontalCenter = "middle";
            bullet1.verticalCenter = "middle";
            
            let triangle = bullet1.createChild(am4core.Triangle);
            triangle.stroke = interfaceColors.getFor("background");
            triangle.strokeWidth = 2;
            triangle.direction = "top";
            triangle.width = 12;
            triangle.height = 12;
            break;
          case "rectangle":
            let bullet2 = series.bullets.push(new am4charts.Bullet());
            bullet2.width = 10;
            bullet2.height = 10;
            bullet2.horizontalCenter = "middle";
            bullet2.verticalCenter = "middle";
            
            let rectangle = bullet2.createChild(am4core.Rectangle);
            rectangle.stroke = interfaceColors.getFor("background");
            rectangle.strokeWidth = 2;
            rectangle.width = 10;
            rectangle.height = 10;
            break;
          default:
            let bullet3 = series.bullets.push(new am4charts.CircleBullet());
            bullet3.circle.stroke = interfaceColors.getFor("background");
            bullet3.circle.strokeWidth = 2;
            break;
        }
        
        valueAxis.renderer.line.strokeOpacity = 1;
        valueAxis.renderer.line.strokeWidth = 2;
        valueAxis.renderer.line.stroke = series.stroke;
        valueAxis.renderer.labels.template.fill = series.stroke;
        valueAxis.renderer.opposite = opposite;
        valueAxis.renderer.grid.template.disabled = true;
      }

      createAxisAndSeries("visits", "Power", false, "circle");
      createAxisAndSeries("views", "Annunciator Status", true, "triangle");
      createAxisAndSeries("hits", "Signal Strength Value", true, "rectangle");

      // Add legend
      datapointChart.legend = new am4charts.Legend();
      datapointChart.legend.useDefaultMarker = true;

      const marker = datapointChart.legend.markers.template;
      const markerColumn = marker.children.getIndex(0);
      marker.height = 12
      marker.width = 12
      const markerColumnActiveState = markerColumn.states.getKey("active");
      // When a legend item is disabled it triggers its active state,
      // test it out:
      markerColumnActiveState.properties.strokeWidth = 2;
      // markerColumnActiveState.properties.stroke = "#000";
      markerColumnActiveState.properties.strokeOpacity = 1;
      markerColumnActiveState.adapter.add("fill", function() {
        return am4core.color("red");
      });

      // markerColumn.cornerRadius(0, 0, 0, 0);
      markerColumn.defaultState.properties.fillOpacity = 0;
      markerColumn.defaultState.properties.strokeWidth = 1;
      markerColumn.defaultState.properties.stroke = am4core.color("#000");
      markerColumn.defaultState.properties.strokeOpacity = 1;
      // markerColumnActiveState.properties.fillOpacity = 0;

            // Add custom image instead
            const checkbox = marker.createChild(am4core.Image);
            checkbox.width = 10;
            checkbox.height = 10;
            checkbox.verticalCenter = "top";
            checkbox.horizontalCenter = "left";

      checkbox.href = "https://cdn.onlinewebfonts.com/svg/img_207414.png";
      checkbox.dx = 1;
      checkbox.dy = 1;

      const checkboxActiveState = checkbox.states.create("active");
      checkboxActiveState.properties.opacity = 0;

      // Add cursor
      datapointChart.cursor = new am4charts.XYCursor();

      this.datapointChart = datapointChart
      

      // generate some random data, quite different range
      function generateChartData() {
        let chartData = [];
        let firstDate = new Date();
        firstDate.setDate(firstDate.getDate() - 100);
        firstDate.setHours(0, 0, 0, 0);

        let visits = 160;
        let hits = 290;
        let views = 700;

        for (var i = 0; i < 15; i++) {
          // we create date objects here. In your data, you can have date strings
          // and then set format of your dates using chart.dataDateFormat property,
          // however when possible, use date objects, as this will speed up chart rendering.
          let newDate = new Date(firstDate);
          newDate.setDate(newDate.getDate() + i);

          visits += Math.round((Math.random()<0.5?1:-1)*Math.random()*10);
          hits += Math.round((Math.random()<0.5?1:-1)*Math.random()*10);
          views += Math.round((Math.random()<0.5?1:-1)*Math.random()*10);

          chartData.push({
            date: newDate,
            visits: visits,
            hits: hits,
            views: views
          });
        }
        return chartData;
      }
    }

    ngOnDestroy() {
        this.zone.runOutsideAngular(() => {
        if (this.chart) {
            this.chart.dispose();
        }
        });
        if (this.chartObjBar) {
          // this.chartObjBar.despose()
        }

    }
    
    getChartData(){
      //         /* ************************************Highchart start********************************************** */
      //         let channelidArray = []
      //         this.graphRenderData = []
      //         let yAxisArray = []
      //         let SeriesName = []
      //         let SerieslabelName = []
      //         let tempGraphObj = {}
    
      //         let isDataObj = false;
      //         this.graphRenderData.map((obj,index)=>{
      //           // if (index == 0) {
      //             tempGraphObj[index] = []
      //           // }
      //           // SeriesName.push(obj.description)
      //           yAxisArray.push({ // third yAxis
      //             gridLineWidth: 0,
      //             lineWidth: 2,
      //             title: {
      //                 text: obj.description,
      //                 // style: {
      //                 //     color: Highcharts.getOptions().colors[index]
      //                 // }
      //             },
      //             labels: {
      //                 format: '{value} ',
      //                 // style: {
      //                 //     color: Highcharts.getOptions().colors[index]
      //                 // }
      //             },
      //             opposite: index%2==0 ? true :false,
      //         })
      //         let TZ = ""
    
      //         isDataObj = isDataObj ? true : (obj.dataPoints.length>0 ? true : false )
      //         if (obj.dataPoints.length) {
      //           SeriesName.push(obj.description /* dataPoints[0].dataChannelDescription*/ ? obj.description : null)//dataPoints[0].dataChannelDescription
      //         }else{
      //           SeriesName.push(obj.description)
      //         }
      //         SerieslabelName.push(obj.textstate+'('+obj.description+')')
      //         // isDataObj = isDataObj ? true : (obj.dataPoints.length ? true : false )
    
      //           obj.dataPoints.map((pointObj,pointIndex)=>{
      //             TZ = pointObj['tzt']
      //             // console.log( new Date(moment(pointObj.eventTime, "YYYY-MM-DD HH:mm:ss:sssZ").toDate()).getTime(),  new Date(pointObj.eventTime+' '+pointObj.tzt).getTime(), pointObj.eventTime);
      //             // console.log(new Date(pointObj.eventTime));
      //             // console.log(new Date( moment( pointObj.eventTime , "YYYY-MM-DD HH:mm:ss:sss").toDate()).getTime());
                  
      //             // tempGraphObj[index].push([new Date(/* moment( */pointObj.eventTime/* , "YYYY-MM-DD HH:mm:ss:sss").toDate() */).getTime(),pointObj.originalValue])
      //             tempGraphObj[index].push([new Date( moment( pointObj.eventTime , "YYYY-MM-DD HH:mm:ss:sss").toDate()).getTime(),pointObj.originalValue])
      //           })
      //           // this.TimeZone = TZ
      //         })
    
      //         let seriesData = [[1174521600000,0.7491],[1174608000000,0.7505],[1174867200000,0.754],[1174953600000,0.7493],[1175040000000,0.7493],[1175126400000,0.7491],[1197936000000,0.6938],[1198022400000,0.6953],[1198108800000,0.697],[1198195200000,0.6955],[1198454400000,0.6946],[1198540800000,0.6946],[1198627200000,0.6946],[1198713600000,0.689],[1198800000000,0.6807],[1199059200000,0.6794],[1199145600000,0.6794],[1199232000000,0.6809],[1199318400000,0.6779],[1199404800000,0.6791],[1199664000000,0.6793],[1199750400000,0.6801],[1199836800000,0.6813],[1199923200000,0.6821],[1200009600000,0.6761],[1200268800000,0.6715],[1200355200000,0.6719],[1200441600000,0.6761],[1200528000000,0.6808],[1200614400000,0.6816],[1200873600000,0.6906],[1200960000000,0.69],[1201046400000,0.6863],[1201132800000,0.6821],[1201219200000,0.6801],[1201478400000,0.6778],[1201564800000,0.677],[1201651200000,0.6753],[1201737600000,0.6726],[1201824000000,0.6717],[1202083200000,0.6745],[1202169600000,0.6809],[1202256000000,0.684],[1202342400000,0.6865],[1202428800000,0.6891],[1202688000000,0.6878],[1202774400000,0.688],[1202860800000,0.6857],[1202947200000,0.6838],[1203033600000,0.6816],[1203292800000,0.6833],[1203379200000,0.6784],[1203465600000,0.6824],[1203552000000,0.6787],[1203638400000,0.6736],[1203897600000,0.675],[1203984000000,0.6724],[1204070400000,0.6648],[1204156800000,0.6614],[1204243200000,0.6594],[1204502400000,0.6579],[1204588800000,0.6577],[1204675200000,0.6582],[1204761600000,0.6529],[1204848000000,0.6487],[1205107200000,0.652],[1205193600000,0.6503],[1205280000000,0.6462],[1205366400000,0.6421],[1205452800000,0.6427],[1205712000000,0.6342],[1205798400000,0.6342],[1205884800000,0.6374],[1205971200000,0.6485],[1206057600000,0.6485],[1206316800000,0.6485],[1206403200000,0.6424],[1206489600000,0.6366],[1206576000000,0.6336],[1206662400000,0.6332],[1206921600000,0.6325],[1207008000000,0.6387],[1207094400000,0.6398],[1207180800000,0.6442],[1207267200000,0.6362],[1207526400000,0.6373],[1207612800000,0.6373],[1207699200000,0.636],[1207785600000,0.63],[1207872000000,0.6317],[1208131200000,0.6303],[1208217600000,0.6319],[1208304000000,0.6279],[1208390400000,0.6301],[1208476800000,0.6338],[1208736000000,0.6291],[1208822400000,0.6278],[1208908800000,0.6275],[1208995200000,0.6343],[1209081600000,0.6413],[1209340800000,0.64],[1209427200000,0.6423],[1209513600000,0.6436],[1209600000000,0.6436],[1209686400000,0.647],[1209945600000,0.6469],[1210032000000,0.6441],[1210118400000,0.6482],[1210204800000,0.6517],[1210291200000,0.647],[1210550400000,0.6482],[1210636800000,0.6464],[1210723200000,0.6478],[1210809600000,0.6463],[1210896000000,0.6453],[1211155200000,0.6421],[1211241600000,0.6395],[1211328000000,0.6349],[1211414400000,0.6348],[1211500800000,0.6353],[1211760000000,0.6346],[1211846400000,0.6346],[1211932800000,0.6388],[1212019200000,0.6431],[1212105600000,0.6449],[1212364800000,0.6444],[1212451200000,0.6414],[1212537600000,0.6467],[1212624000000,0.6494],[1212710400000,0.6412],[1212969600000,0.6337],[1213056000000,0.6442],[1213142400000,0.6446],[1213228800000,0.6487],[1213315200000,0.6522],[1213574400000,0.647],[1213660800000,0.6462],[1213747200000,0.6456],[1213833600000,0.6461],[1213920000000,0.6407],[1214179200000,0.6444],[1214265600000,0.6424],[1214352000000,0.6412],[1214438400000,0.6358],[1214524800000,0.6351],[1214784000000,0.6345],[1214870400000,0.634],[1214956800000,0.6328],[1215043200000,0.6296],[1215129600000,0.6382],[1215388800000,0.639],[1215475200000,0.6376],[1215561600000,0.6364],[1215648000000,0.6367],[1215734400000,0.6316],[1215993600000,0.6311],[1216080000000,0.6255],[1216166400000,0.6295],[1216252800000,0.6311],[1216339200000,0.6324],[1216598400000,0.6307],[1216684800000,0.6283],[1216771200000,0.6354],[1216857600000,0.638],[1216944000000,0.6357],[1217203200000,0.6352],[1217289600000,0.6368],[1217376000000,0.6416],[1217462400000,0.6407],[1217548800000,0.6422],[1217808000000,0.6425],[1217894400000,0.6458],[1217980800000,0.6462],[1218067200000,0.6465],[1218153600000,0.6635],[1218412800000,0.6662],[1218499200000,0.6709],[1218585600000,0.6711],[1218672000000,0.6709],[1218758400000,0.679],[1219017600000,0.6802],[1219104000000,0.6814],[1219190400000,0.6788],[1219276800000,0.6751],[1219363200000,0.6754],[1219622400000,0.6773],[1219708800000,0.6851],[1219795200000,0.6773],[1219881600000,0.6771],[1219968000000,0.6788],[1220227200000,0.684],[1220313600000,0.689],[1220400000000,0.6926],[1220486400000,0.6903],[1220572800000,0.702],[1220832000000,0.7036],[1220918400000,0.7071],[1221004800000,0.7096],[1221091200000,0.7178],[1221177600000,0.711],[1221436800000,0.7068],[1221523200000,0.701],[1221609600000,0.7031],[1221696000000,0.6897],[1221782400000,0.7025],[1222041600000,0.6864],[1222128000000,0.6789],[1222214400000,0.6808],[1222300800000,0.6804],[1222387200000,0.6832],[1222646400000,0.697],[1222732800000,0.6993],[1222819200000,0.7103],[1222905600000,0.7194],[1222992000000,0.723],[1223251200000,0.7336],[1223337600000,0.7337],[1223424000000,0.7284],[1223510400000,0.731],[1223596800000,0.7365],[1223856000000,0.7333],[1223942400000,0.7273],[1224028800000,0.734],[1224115200000,0.7405],[1224201600000,0.7461],[1224460800000,0.745],[1224547200000,0.7586],[1224633600000,0.7787],[1224720000000,0.7807],[1224806400000,0.794],[1225065600000,0.8027],[1225152000000,0.7984],[1225238400000,0.7832],[1225324800000,0.7673],[1225411200000,0.784],[1225670400000,0.78],[1225756800000,0.7801],[1225843200000,0.7771],[1225929600000,0.7832],[1226016000000,0.784],[1226275200000,0.7758],[1226361600000,0.7846],[1226448000000,0.7982],[1226534400000,0.7985],[1226620800000,0.7891],[1226880000000,0.79],[1226966400000,0.7904],[1227052800000,0.7916],[1227139200000,0.7974],[1227225600000,0.7936],[1227484800000,0.783],[1227571200000,0.7807],[1227657600000,0.7732],[1227744000000,0.7753],[1227830400000,0.7858],[1228089600000,0.7932],[1228176000000,0.7877],[1228262400000,0.7923],[1228348800000,0.7925],[1228435200000,0.7897],[1228694400000,0.7781],[1228780800000,0.779],[1228867200000,0.7738],[1228953600000,0.7568],[1229040000000,0.7497],[1229299200000,0.7403],[1229385600000,0.7306],[1229472000000,0.7114],[1229558400000,0.6843],[1229644800000,0.7175],[1229904000000,0.7159],[1229990400000,0.7155],[1230076800000,0.7141],[1230163200000,0.7141],[1230249600000,0.7141],[1230508800000,0.7009],[1230595200000,0.7094],[1230681600000,0.7186],[1230768000000,0.7186],[1230854400000,0.7213],[1231113600000,0.7364],[1231200000000,0.7502],[1231286400000,0.7357],[1231372800000,0.7345],[1231459200000,0.7309],[1231718400000,0.7467],[1231804800000,0.7541],[1231891200000,0.7592],[1231977600000,0.7643],[1232064000000,0.7537],[1232323200000,0.7587],[1232409600000,0.7735],[1232496000000,0.7747],[1232582400000,0.7703],[1232668800000,0.7817],[1232928000000,0.7699],[1233014400000,0.7592],[1233100800000,0.7542],[1233187200000,0.7628],[1233273600000,0.7804],[1233532800000,0.7838],[1233619200000,0.7784],[1233705600000,0.7803],[1233792000000,0.7796],[1233878400000,0.7816],[1234137600000,0.7689],[1234224000000,0.7713],[1234310400000,0.773],[1234396800000,0.7793],[1234483200000,0.7799],[1234742400000,0.7835],[1234828800000,0.7916],[1234915200000,0.794],[1235001600000,0.7872],[1235088000000,0.7943],[1235347200000,0.7815],[1235433600000,0.7836],[1235520000000,0.7817],[1235606400000,0.7825],[1235692800000,0.791],[1235952000000,0.794],[1236038400000,0.7928],[1236124800000,0.7966],[1236211200000,0.7966],[1236297600000,0.7901],[1236556800000,0.796],[1236643200000,0.7824],[1236729600000,0.7822],[1236816000000,0.7825],[1236902400000,0.775],[1237161600000,0.7669],[1237248000000,0.7728],[1237334400000,0.7617],[1237420800000,0.7316],[1237507200000,0.7382],[1237766400000,0.7377],[1237852800000,0.7405],[1237939200000,0.7412],[1238025600000,0.735],[1238112000000,0.7523],[1238371200000,0.7581],[1238457600000,0.7515],[1238544000000,0.755],[1238630400000,0.7468],[1238716800000,0.745],[1238976000000,0.7411],[1239062400000,0.7545],[1239148800000,0.7559],[1239235200000,0.7535],[1239321600000,0.7535],[1239580800000,0.7535],[1239667200000,0.7533],[1239753600000,0.7592],[1239840000000,0.7579],[1239926400000,0.7659],[1240185600000,0.7713],[1240272000000,0.7734],[1240358400000,0.7725],[1240444800000,0.7664],[1240531200000,0.7558],[1240790400000,0.762],[1240876800000,0.7698],[1240963200000,0.7539],[1241049600000,0.7534],[1241136000000,0.7534],[1241395200000,0.7564],[1241481600000,0.7462],[1241568000000,0.7507],[1241654400000,0.7484],[1241740800000,0.745],[1242000000000,0.7368],[1242086400000,0.7309],[1242172800000,0.7342],[1242259200000,0.7374],[1242345600000,0.7399],[1242604800000,0.7412],[1242691200000,0.7347],[1242777600000,0.7306],[1242864000000,0.7263],[1242950400000,0.7158],[1243209600000,0.7139],[1243296000000,0.7191],[1243382400000,0.7195],[1243468800000,0.7218],[1243555200000,0.7094],[1243814400000,0.7033],[1243900800000,0.7024],[1243987200000,0.704],[1244073600000,0.7096],[1244160000000,0.7055],[1244419200000,0.7213],[1244505600000,0.7165],[1244592000000,0.7092],[1244678400000,0.716],[1244764800000,0.7142],[1245024000000,0.7221],[1245110400000,0.72],[1245196800000,0.7226],[1245283200000,0.7185],[1245369600000,0.7179],[1245628800000,0.7217],[1245715200000,0.7155],[1245801600000,0.7129],[1245888000000,0.7175],[1245974400000,0.7095],[1246233600000,0.7114],[1246320000000,0.7076],[1246406400000,0.7095],[1246492800000,0.7119],[1246579200000,0.7139],[1246838400000,0.7197],[1246924800000,0.7134],[1247011200000,0.7195],[1247097600000,0.7149],[1247184000000,0.7195],[1247443200000,0.7157],[1247529600000,0.7148],[1247616000000,0.7099],[1247702400000,0.7078],[1247788800000,0.7098],[1248048000000,0.7035],[1248134400000,0.7032],[1248220800000,0.7048],[1248307200000,0.7029],[1248393600000,0.703],[1248652800000,0.7009],[1248739200000,0.7029],[1248825600000,0.7091],[1248912000000,0.7117],[1248998400000,0.7074],[1249257600000,0.6993],[1249344000000,0.6953],[1249430400000,0.6941],[1249516800000,0.696],[1249603200000,0.6966],[1249862400000,0.7042],[1249948800000,0.706],[1250035200000,0.7058],[1250121600000,0.6997],[1250208000000,0.6997],[1250467200000,0.7107],[1250553600000,0.7093],[1250640000000,0.7087],[1250726400000,0.7022],[1250812800000,0.6979],[1251072000000,0.6983],[1251158400000,0.6982],[1251244800000,0.7009],[1251331200000,0.701],[1251417600000,0.6963],[1251676800000,0.7008],[1251763200000,0.6987],[1251849600000,0.7033],[1251936000000,0.6977],[1252022400000,0.7013],[1252281600000,0.6979],[1252368000000,0.691],[1252454400000,0.6887],[1252540800000,0.6876],[1252627200000,0.6853],[1252886400000,0.6869],[1252972800000,0.6845],[1253059200000,0.6817],[1253145600000,0.6798],[1253232000000,0.6801],[1253491200000,0.6823],[1253577600000,0.6767],[1253664000000,0.6766],[1253750400000,0.6772],[1253836800000,0.6818],[1254096000000,0.6827],[1254182400000,0.6874],[1254268800000,0.683],[1254355200000,0.6879],[1254441600000,0.688],[1254700800000,0.6843],[1254787200000,0.6794],[1254873600000,0.6806],[1254960000000,0.6775],[1255046400000,0.6781],[1255305600000,0.6774],[1255392000000,0.6729],[1255478400000,0.6721],[1255564800000,0.6729],[1255651200000,0.6726],[1255910400000,0.6704],[1255996800000,0.6681],[1256083200000,0.6703],[1256169600000,0.6668],[1256256000000,0.6659],[1256515200000,0.6659],[1256601600000,0.6724],[1256688000000,0.6765],[1256774400000,0.6763],[1256860800000,0.6758],[1257120000000,0.6771],[1257206400000,0.6823],[1257292800000,0.6776],[1257379200000,0.6727],[1257465600000,0.673],[1257724800000,0.6675],[1257811200000,0.6683],[1257897600000,0.6651],[1257984000000,0.6703],[1258070400000,0.6727],[1258329600000,0.6683],[1258416000000,0.6724],[1258502400000,0.6687],[1258588800000,0.6729],[1258675200000,0.6751],[1258934400000,0.6682],[1259020800000,0.6681],[1259107200000,0.6631],[1259193600000,0.6636],[1259280000000,0.6704],[1259539200000,0.6657],[1259625600000,0.6635],[1259712000000,0.6628],[1259798400000,0.6615],[1259884800000,0.6638],[1260144000000,0.6764],[1260230400000,0.677],[1260316800000,0.6772],[1260403200000,0.679],[1260489600000,0.6777],[1260748800000,0.6828],[1260835200000,0.6878],[1260921600000,0.6869],[1261008000000,0.6973],[1261094400000,0.6976],[1261353600000,0.6961],[1261440000000,0.7004],[1261526400000,0.7006],[1261612800000,0.6946],[1261699200000,0.6946],[1261958400000,0.6943],[1262044800000,0.693],[1262131200000,0.6975],[1262217600000,0.6943],[1262304000000,0.6943],[1262563200000,0.6951],[1262649600000,0.6925],[1262736000000,0.697],[1262822400000,0.6992],[1262908800000,0.7007],[1263168000000,0.6884],[1263254400000,0.6907],[1263340800000,0.6868],[1263427200000,0.6904],[1263513600000,0.6958],[1263772800000,0.696],[1263859200000,0.7004],[1263945600000,0.7077],[1264032000000,0.7111],[1264118400000,0.7076],[1264377600000,0.7068],[1264464000000,0.7101],[1264550400000,0.7107],[1264636800000,0.7144],[1264723200000,0.7161],[1264982400000,0.7189],[1265068800000,0.7176],[1265155200000,0.7152],[1265241600000,0.7223],[1265328000000,0.7305],[1265587200000,0.7314],[1265673600000,0.7268],[1265760000000,0.7279],[1265846400000,0.7291],[1265932800000,0.7369],[1266192000000,0.735],[1266278400000,0.7328],[1266364800000,0.7286],[1266451200000,0.7372],[1266537600000,0.7398],[1266796800000,0.734],[1266883200000,0.7366],[1266969600000,0.7383],[1267056000000,0.7414],[1267142400000,0.737],[1267401600000,0.7395],[1267488000000,0.7382],[1267574400000,0.7332],[1267660800000,0.7317],[1267747200000,0.7364],[1268006400000,0.7321],[1268092800000,0.7377],[1268179200000,0.7349],[1268265600000,0.7323],[1268352000000,0.7266],[1268611200000,0.7298],[1268697600000,0.7288],[1268784000000,0.7271],[1268870400000,0.7322],[1268956800000,0.7382],[1269216000000,0.7424],[1269302400000,0.7398],[1269388800000,0.7498],[1269475200000,0.7488],[1269561600000,0.749],[1269820800000,0.7424],[1269907200000,0.7418],[1269993600000,0.742],[1270080000000,0.7426],[1270166400000,0.7426],[1270425600000,0.7426],[1270512000000,0.7466],[1270598400000,0.7497],[1270684800000,0.7522],[1270771200000,0.7473],[1271030400000,0.7362],[1271116800000,0.7363],[1271203200000,0.7346],[1271289600000,0.7384],[1271376000000,0.7389],[1271635200000,0.7446],[1271721600000,0.7416],[1271808000000,0.7479],[1271894400000,0.7498],[1271980800000,0.7514],[1272240000000,0.7508],[1272326400000,0.7525],[1272412800000,0.7551],[1272499200000,0.7545],[1272585600000,0.7511],[1272844800000,0.7555],[1272931200000,0.7641],[1273017600000,0.7739],[1273104000000,0.7858],[1273190400000,0.7847],[1273449600000,0.7712],[1273536000000,0.7876],[1273622400000,0.7884],[1273708800000,0.7946],[1273795200000,0.8006],[1274054400000,0.8099],[1274140800000,0.8047],[1274227200000,0.8151],[1274313600000,0.8109],[1274400000000,0.8003],[1274659200000,0.8092],[1274745600000,0.8182],[1274832000000,0.8125],[1274918400000,0.8161],[1275004800000,0.8076],[1275264000000,0.8126],[1275350400000,0.8228],[1275436800000,0.8186],[1275523200000,0.8152],[1275609600000,0.8293],[1275868800000,0.8363],[1275955200000,0.8375],[1276041600000,0.8327],[1276128000000,0.8303],[1276214400000,0.8247],[1276473600000,0.8165],[1276560000000,0.8159]]
      //         // console.log(tempGraphObj)
      //         // console.log(isDataObj);
              
              
      //       //   8**************************************      for multiple series            **************

      //       //   for (const key in tempGraphObj) {
      //       //     if (tempGraphObj.hasOwnProperty(key)) {
      //       //       const element = tempGraphObj[key];
      //       //       // console.log(element , "element");
      //       //       // isDataObj = isDataObj ? true : (element.length ? true : false )
                  
      //       //       seriesData.push({
      //       //         data: element,
      //       //         lineWidth: 1,
      //       //         marker: {
      //       //           symbol: 'circle'
      //       //         },
      //       //         yAxis: Number(key),
      //       //         name: SerieslabelName[key]
      //       //     })
      //       //     }
      //       //   }
    
      //         let title =  ""//data.statusCode == 103 ?  data.responseMessage : (!isDataObj ? "No Data Available" :assetChannelData.graphName)
      //         setTimeout(() => {
    
    
      //           (function(H) {
      //             H.wrap(H.Legend.prototype, 'positionCheckboxes', function(p, scrollOffset) {
      //               var alignAttr = this.group.alignAttr,
      //                 translateY,
      //                 clipHeight = this.clipHeight || this.legendHeight;
                
      //               if (alignAttr) {
      //                 translateY = alignAttr.translateY;
      //                 H.each(this.allItems, function(item) {
      //                   var checkbox = item.checkbox,
      //                     bBox = item.legendItem.getBBox(true),
      //                     top;
                
      //                   if (checkbox) {
      //                     top = (translateY + checkbox.y + (scrollOffset || 0) + 2);
      //                     H.css(checkbox, {
      //                       left: (alignAttr.translateX + item.checkboxOffset + checkbox.x - 80 - bBox.width) + 'px',
      //                       top: (top+4) + 'px',
      //                       display: top > translateY - 6 && top < translateY + clipHeight - 6 ? '' : 'none'
      //                     });
      //                   }
      //                 });
      //               }
      //             });
      //           })(Highcharts);
    
    
    
      //             let chartObj = Highcharts.chart('chart-container-asset', {
    
      //               chart: {
      //                   zoomType: 'x',
      //                   type: 'spline'
      //               },
      //               // exporting: { enabled: false },
      //               title: {
      //                   text: title
      //               },
      //               time:{
      //                 useUTC:false,
      //               },
      //               // subtitle: {
      //               //     text: ''
      //               // },
      //               // noData: "no data available",
      //               tooltip: {
      //                   // valueDecimals: 2,
      //                   // crosshairs: true,
      //                   shared: true,
      //                   xDateFormat: '%Y-%m-%d',
                        
      //               },
      //               legend: {
      //                 enabled : true,
      //                 // itemDistance: 50,
                      
      //                 itemMarginTop: 4,
      //                 itemMarginBottom: 4,
      //                 // enabled: true,
      //                 // symbolPadding: 20
      //               //   useHTML: true,
      //               //   symbolWidth: 0,
      //               //   labelFormatter: function() {
      //               //     return '<input type="checkbox">' + series.name
      //               //   }
      //               },
      //               plotOptions:{
      //                 series:{
      //                   showCheckbox:true,
      //                   selected:true,
      //                   showInLegend: true,
      //                   events: {
      //                     legendItemClick: function() {
      //                       return false;
      //                     },
      //                     checkboxClick: function (event) {
      //                         if (event.checked) {
      //                             this.show();
      //                         } else {
      //                             this.hide();
      //                         }
      //                     }
      //                 }
      //                 }
      //               },
    
    
      //              /*  exporting: {
      //                 buttons: {
      //                     contextButton: {
      //                         // text: 'DOWNLOAD',
      //                         theme: {
      //                             fill: 'transparent',
      //                             //'stroke-width': 1,
      //                             //stroke: 'white',
      //                             //r: 1,
      //                             style: {
      //                                 color: 'white',
      //                                 fontSize: '10px'
      //                             },   
      
      //                             // states: {
      //                             //     hover: {
      //                             //         fill: 'transparent'
      //                             //     },
      //                             //     select: {
      //                             //         fill: 'transparent'
      //                             //     }
      //                             // }
      //                         },
      //                         menuItems: [{
      //                             text: 'Download PNG image',
      //                             onclick: function () {
      //                                 this.exportChart({
      //                                     type: 'image/png'
      //                                 });
      //                             }
      //                         }, {
      //                             text: 'Download JPEG image',
      //                             onclick: function () {
      //                                 this.exportChart({
      //                                     type: 'image/jpeg'
      //                                 });
      //                             }
      //                         }, {
      //                             text: 'Download PDF document',
      //                             onclick: function () {
      //                                 this.exportChart({
      //                                     type: 'application/pdf'
      //                                 });
      //                             }
      
      //                         }]
      //                     }
      //                 },
      //                 // filename: 'Map',
      //                 allowHTML: true,
      //                 chartOptions: {
      //                     chart: {
      //                         style: {
      //                             fontFamily: '"Gotham SSm A" "Gotham SSm B"'
      //                         },
      //                         height: 880,
      //                         spacingBottom: 300,
      //                         marginTop: 50,
      //                         width: 1010,
      //                         // backgroundColor: 'rgba(0, 0, 0, 0)',
      // //                         events: {
      // //                             load: function () {
      // //                                 this.series[0].update({
      // //                                     nullColor: 'rgba(245, 245, 245, 1)',
      // //                                     borderColor: 'rgba(192, 192, 192, 1)'
      // //                                 });
      // //                                 //DisableGeographiesOnExport(this);
      // //                                 //this.renderer.image('http://www.eiu.com/images/logos/EIU_logo2x.png', 0, 740, 100, 25).add();
      // //                                 //this.renderer.image('http://data.eiu.com/assets/images/charts/bubbles-legend.png', 600, 565, 20, 16).add();
      // //                                 this.renderer.label('<b>Size of opportunity</b>', 620, 565, null, null, null, true).add();
      // //                                 //var label = this.renderer.label(getExportPropertiesTable(), null, null, null, null, null, true).add();
      
      // // //                                label.align(Highcharts.extend(label.getBBox(), {
      // // //                                    align: 'center',
      // // //                                    x: 0, // offset
      // // //                                    verticalAlign: 'bottom',
      // // //                                    y: 160 // offset
      // // //                                }), null, 'spacingBox');  
      // //                             }
      // //                         }
      //                     },
      //                     legend: {
      //                         enabled: true,
      //                         verticalAlign: 'bottom',
      //                         align: 'center',
      //                         itemMarginTop: -10,
      //                         // itemStyle: {
      //                         //     color: 'rgb(0,0,0)'
      //                         // },
      //                         symbolRadius: 6,
      //                         symbolHeight: 13,
      //                         symbolWidth: 13                                                
      //                     },
      //                     // credits: {
      //                     //     enabled: true,
      //                     //     text: 'Copyright ©2015 The Economist Intellligence Unit.  Output generated April 30th 2014 11:22 GMT+00:00',
      //                     //     position: {
      //                     //       align: 'left',
      //                     //       x: 110,
      //                     //       verticalAlign: 'bottom',
      //                     //       y: -115
      //                     //     }
      //                     // },
      //                     title: {
      //                         text: "Asset Graph",
      //                         style: {
      //                             fontWeight: 'bold'
      //                         }
      //                     }
      //                 }
      //             },   */  
    
                    
      //               xAxis: {
      //                   type: 'datetime'
      //               },
      //               // yAxis: yAxisArray,
    
      //               // series: seriesData    // -----------for multiple series
      //               series:[{
      //                   // type: 'area',
      //                   name: 'Current Year',
      //                   data: seriesData
      //               },
      //               {
      //                   // type: 'area',
      //                   name: 'Previous Year',
      //                   data: seriesData
      //               }]
      //           });
    
    
      //           // chartObj.exportChart()
      //         }, 200);


      this.zone.runOutsideAngular(() => {
            
        let chart = am4core.create("chart-container-asset", am4charts.XYChart);

        chart.paddingRight = 20;

        let data = [];
        let visits = 10;
        let visits2 = 10;
        for (let i = 1; i < 366; i++) {

            visits = (visits/2)
            visits2 = (visits2/2)

            visits += Math.round((Math.random() /* < 0.5 ? 1 : 10 */) * Math.random() * 10);
            // visits2 += Math.round((Math.random() /* < 0.5 ? 1 : 10 */) * Math.random() * 100);
            data.push({ date: new Date(2018, 0, i), name: "name" + i, value: visits });
        }

        chart.data = data;

        console.log(data);
        

        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.renderer.minWidth = 35;

        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.dateX = "date";
        series.dataFields.valueY = "value";
        series.strokeWidth = 2;
        series.tensionX = 0.7;
        series.fillOpacity = 0.1;
        series.connect = false;
        series.stacked = false;
        series.propertyFields.fill = "color";
        series.propertyFields.stroke = "color";
        series.tooltipText = "Data_point_name : {valueY.value}";

        chart.invalidateData();

        // let series2 = chart.series.push(new am4charts.LineSeries());
        // series2.dataFields.dateX = "date";
        // series2.dataFields.valueY = "value2";

        // series2.tooltipText = "value :{valueY.value}";
        chart.cursor = new am4charts.XYCursor();

        
        chart.legend = new am4charts.Legend();
        chart.legend.position = "bottom";
        

        let scrollbarX = new am4charts.XYChartScrollbar();
        scrollbarX.series.push(series);
        // scrollbarX.series.push(series2);
        chart.scrollbarX = scrollbarX;
        chart.scrollbarX.parent = chart.bottomAxesContainer;

        this.chart = chart;
        
        // let chart = am4core.create("chartdiv", am4charts.XYChart);

        // // ... chart code goes here ...

        // this.chart = chart;
    });
    
    
              /* ************************************Highchart end********************************************** */
    }

    getRuntimeGraphData(){
          /* ************************************Highchart start********************************************** */
          let channelidArray = []
          this.graphRenderData = []
          let yAxisArray = []
          let SeriesName = []
          let SerieslabelName = []
          let tempGraphObj = {}

          let isDataObj = false;
          this.graphRenderData.map((obj,index)=>{
            // if (index == 0) {
              tempGraphObj[index] = []
            // }
            // SeriesName.push(obj.description)
            yAxisArray.push({ // third yAxis
              gridLineWidth: 0,
              lineWidth: 2,
              title: {
                  text: obj.description,
                  // style: {
                  //     color: Highcharts.getOptions().colors[index]
                  // }
              },
              labels: {
                  format: '{value} ',
                  // style: {
                  //     color: Highcharts.getOptions().colors[index]
                  // }
              },
              opposite: index%2==0 ? true :false,
          })
          let TZ = ""

          isDataObj = isDataObj ? true : (obj.dataPoints.length>0 ? true : false )
          if (obj.dataPoints.length) {
            SeriesName.push(obj.description /* dataPoints[0].dataChannelDescription*/ ? obj.description : null)//dataPoints[0].dataChannelDescription
          }else{
            SeriesName.push(obj.description)
          }
          SerieslabelName.push(obj.textstate+'('+obj.description+')')
          // isDataObj = isDataObj ? true : (obj.dataPoints.length ? true : false )

            obj.dataPoints.map((pointObj,pointIndex)=>{
              TZ = pointObj['tzt']
              // console.log( new Date(moment(pointObj.eventTime, "YYYY-MM-DD HH:mm:ss:sssZ").toDate()).getTime(),  new Date(pointObj.eventTime+' '+pointObj.tzt).getTime(), pointObj.eventTime);
              // console.log(new Date(pointObj.eventTime));
              // console.log(new Date( moment( pointObj.eventTime , "YYYY-MM-DD HH:mm:ss:sss").toDate()).getTime());
              
              // tempGraphObj[index].push([new Date(/* moment( */pointObj.eventTime/* , "YYYY-MM-DD HH:mm:ss:sss").toDate() */).getTime(),pointObj.originalValue])
              tempGraphObj[index].push([new Date( moment( pointObj.eventTime , "YYYY-MM-DD HH:mm:ss:sss").toDate()).getTime(),pointObj.originalValue])
            })
            // this.TimeZone = TZ
          })

          let seriesData = [[1214265600000,6424],[1214352000000,6412],[1214438400000,6358],[1214524800000,6351],[1214784000000,6345],[1214870400000,634],[1214956800000,6328],[1215043200000,6296],[1215129600000,6382],[1215388800000,639],[1215475200000,6376],[1215561600000,6364],[1215648000000,6367],[1215734400000,6316],[1215993600000,6311],[1216080000000,6255],[1216166400000,6295],[1216252800000,6311],[1216339200000,6324],[1216598400000,6307],[1216684800000,6283],[1216771200000,6354],[1216857600000,638],[1216944000000,6357],[1217203200000,6352],[1217289600000,6368],[1217376000000,6416],[1217462400000,6407],[1217548800000,6422],[1217808000000,6425],[1217894400000,6458],[1217980800000,6462],[1218067200000,6465],[1218153600000,6635],[1218412800000,6662],[1218499200000,6709],[1218585600000,6711],[1218672000000,6709],[1218758400000,679],[1219017600000,6802],[1219104000000,6814],[1219190400000,6788],[1219276800000,6751],[1219363200000,6754],[1219622400000,6773],[1219708800000,6851],[1219795200000,6773],[1219881600000,6771],[1219968000000,6788],[1220227200000,684],[1220313600000,689],[1220400000000,6926],[1220486400000,6903],[1220572800000,702],[1220832000000,7036],[1220918400000,7071],[1221004800000,7096],[1221091200000,7178],[1221177600000,711],[1221436800000,7068],[1221523200000,701],[1221609600000,7031],[1221696000000,6897],[1221782400000,7025],[1222041600000,6864],[1222128000000,6789],[1222214400000,6808],[1222300800000,6804],[1222387200000,6832],[1222646400000,697],[1222732800000,6993],[1222819200000,7103],[1222905600000,7194],[1222992000000,723],[1223251200000,7336],[1223337600000,7337],[1223424000000,7284],[1223510400000,731],[1223596800000,7365],[1223856000000,7333],[1223942400000,7273],[1224028800000,734],[1224115200000,7405],[1224201600000,7461],[1224460800000,745],[1224547200000,7586],[1224633600000,7787],[1224720000000,7807],[1224806400000,794],[1225065600000,8027],[1225152000000,7984],[1225238400000,7832],[1225324800000,7673],[1225411200000,784],[1225670400000,78],[1225756800000,7801],[1225843200000,7771],[1225929600000,7832],[1226016000000,784],[1226275200000,7758],[1226361600000,7846],[1226448000000,7982],[1226534400000,7985],[1226620800000,7891],[1226880000000,79],[1226966400000,7904],[1227052800000,7916],[1227139200000,7974],[1227225600000,7936],[1227484800000,783],[1227571200000,7807],[1227657600000,7732],[1227744000000,7753],[1227830400000,7858],[1228089600000,7932],[1228176000000,7877],[1228262400000,7923],[1228348800000,7925],[1228435200000,7897],[1228694400000,7781],[1228780800000,779],[1228867200000,7738],[1228953600000,7568],[1229040000000,7497],[1229299200000,7403],[1229385600000,7306],[1229472000000,7114],[1229558400000,6843],[1229644800000,7175],[1229904000000,7159],[1229990400000,7155],[1230076800000,7141],[1230163200000,7141],[1230249600000,7141],[1230508800000,7009],[1230595200000,7094],[1230681600000,7186],[1230768000000,7186],[1230854400000,7213],[1231113600000,7364],[1231200000000,7502],[1231286400000,7357],[1231372800000,7345],[1231459200000,7309],[1231718400000,7467],[1231804800000,7541],[1231891200000,7592],[1231977600000,7643],[1232064000000,7537],[1232323200000,7587],[1232409600000,7735],[1232496000000,7747],[1232582400000,7703],[1232668800000,7817],[1232928000000,7699],[1233014400000,7592],[1233100800000,7542],[1233187200000,7628],[1233273600000,7804],[1233532800000,7838],[1233619200000,7784],[1233705600000,7803],[1233792000000,7796],[1233878400000,7816],[1234137600000,7689],[1234224000000,7713],[1234310400000,773],[1234396800000,7793],[1234483200000,7799],[1234742400000,7835],[1234828800000,7916],[1234915200000,794],[1235001600000,7872],[1235088000000,7943],[1235347200000,7815],[1235433600000,7836],[1235520000000,7817],[1235606400000,7825],[1235692800000,791],[1235952000000,794],[1236038400000,7928],[1236124800000,7966],[1236211200000,7966],[1236297600000,7901],[1236556800000,796],[1236643200000,7824],[1236729600000,7822],[1236816000000,7825],[1236902400000,775],[1237161600000,7669],[1237248000000,7728],[1237334400000,7617],[1237420800000,7316],[1237507200000,7382],[1237766400000,7377],[1237852800000,7405],[1237939200000,7412],[1238025600000,735],[1238112000000,7523],[1238371200000,7581],[1238457600000,7515],[1238544000000,755],[1238630400000,7468],[1238716800000,745],[1238976000000,7411],[1239062400000,7545],[1239148800000,7559],[1239235200000,7535],[1239321600000,7535],[1239580800000,7535],[1239667200000,7533],[1239753600000,7592],[1239840000000,7579],[1239926400000,7659],[1240185600000,7713],[1240272000000,7734],[1240358400000,7725],[1240444800000,7664],[1240531200000,7558],[1240790400000,762],[1240876800000,7698],[1240963200000,7539],[1241049600000,7534],[1241136000000,7534],[1241395200000,7564],[1241481600000,7462],[1241568000000,7507],[1241654400000,7484],[1241740800000,745],[1242000000000,7368],[1242086400000,7309],[1242172800000,7342],[1242259200000,7374],[1242345600000,7399],[1242604800000,7412],[1242691200000,7347],[1242777600000,7306],[1242864000000,7263],[1242950400000,7158],[1243209600000,7139],[1243296000000,7191],[1243382400000,7195],[1243468800000,7218],[1243555200000,7094],[1243814400000,7033],[1243900800000,7024],[1243987200000,704],[1244073600000,7096],[1244160000000,7055],[1244419200000,7213],[1244505600000,7165],[1244592000000,7092],[1244678400000,716],[1244764800000,7142],[1245024000000,7221],[1245110400000,72],[1245196800000,7226],[1245283200000,7185],[1245369600000,7179],[1245628800000,7217],[1245715200000,7155],[1245801600000,7129],[1245888000000,7175],[1245974400000,7095],[1246233600000,7114],[1246320000000,7076],[1246406400000,7095],[1246492800000,7119],[1246579200000,7139],[1246838400000,7197],[1246924800000,7134],[1247011200000,7195],[1247097600000,7149],[1247184000000,7195],[1247443200000,7157],[1247529600000,7148],[1247616000000,7099],[1247702400000,7078],[1247788800000,7098],[1248048000000,7035],[1248134400000,7032],[1248220800000,7048],[1248307200000,7029],[1248393600000,703],[1248652800000,7009],[1248739200000,7029],[1248825600000,7091],[1248912000000,7117],[1248998400000,7074],[1249257600000,6993],[1249344000000,6953],[1249430400000,6941],[1249516800000,696],[1249603200000,6966],[1249862400000,7042],[1249948800000,706],[1250035200000,7058],[1250121600000,6997],[1250208000000,6997],[1250467200000,7107],[1250553600000,7093],[1250640000000,7087],[1250726400000,7022],[1250812800000,6979],[1251072000000,6983],[1251158400000,6982],[1251244800000,7009],[1251331200000,701],[1251417600000,6963],[1251676800000,7008],[1251763200000,6987],[1251849600000,7033],[1251936000000,6977],[1252022400000,7013],[1252281600000,6979],[1252368000000,691],[1252454400000,6887],[1252540800000,6876],[1252627200000,6853],[1252886400000,6869],[1252972800000,6845],[1253059200000,6817],[1253145600000,6798],[1253232000000,6801],[1253491200000,6823],[1253577600000,6767],[1253664000000,6766],[1253750400000,6772],[1253836800000,6818],[1254096000000,6827],[1254182400000,6874],[1254268800000,683],[1254355200000,6879],[1254441600000,688],[1254700800000,6843],[1254787200000,6794],[1254873600000,6806],[1254960000000,6775],[1255046400000,6781],[1255305600000,6774],[1255392000000,6729],[1255478400000,6721],[1255564800000,6729],[1255651200000,6726],[1255910400000,6704],[1255996800000,6681],[1256083200000,6703],[1256169600000,6668],[1256256000000,6659],[1256515200000,6659],[1256601600000,6724],[1256688000000,6765],[1256774400000,6763],[1256860800000,6758],[1257120000000,6771],[1257206400000,6823],[1257292800000,6776],[1257379200000,6727],[1257465600000,673],[1257724800000,6675],[1257811200000,6683],[1257897600000,6651],[1257984000000,6703],[1258070400000,6727],[1258329600000,6683],[1258416000000,6724],[1258502400000,6687],[1258588800000,6729],[1258675200000,6751],[1258934400000,6682],[1259020800000,6681],[1259107200000,6631],[1259193600000,6636],[1259280000000,6704],[1259539200000,6657],[1259625600000,6635],[1259712000000,6628],[1259798400000,6615],[1259884800000,6638],[1260144000000,6764],[1260230400000,677],[1260316800000,6772],[1260403200000,679],[1260489600000,6777],[1260748800000,6828],[1260835200000,6878],[1260921600000,6869],[1261008000000,6973],[1261094400000,6976],[1261353600000,6961],[1261440000000,7004],[1261526400000,7006],[1261612800000,6946],[1261699200000,6946],[1261958400000,6943],[1262044800000,693],[1262131200000,6975],[1262217600000,6943],[1262304000000,6943],[1262563200000,6951],[1262649600000,6925],[1262736000000,697],[1262822400000,6992],[1262908800000,7007],[1263168000000,6884],[1263254400000,6907],[1263340800000,6868],[1263427200000,6904],[1263513600000,6958],[1263772800000,696],[1263859200000,7004],[1263945600000,7077],[1264032000000,7111],[1264118400000,7076],[1264377600000,7068],[1264464000000,7101],[1264550400000,7107],[1264636800000,7144],[1264723200000,7161],[1264982400000,7189],[1265068800000,7176],[1265155200000,7152],[1265241600000,7223],[1265328000000,7305],[1265587200000,7314],[1265673600000,7268],[1265760000000,7279],[1265846400000,7291],[1265932800000,7369],[1266192000000,735],[1266278400000,7328],[1266364800000,7286],[1266451200000,7372],[1266537600000,7398],[1266796800000,734],[1266883200000,7366],[1266969600000,7383],[1267056000000,7414],[1267142400000,737],[1267401600000,7395],[1267488000000,7382],[1267574400000,7332],[1267660800000,7317],[1267747200000,7364],[1268006400000,7321],[1268092800000,7377],[1268179200000,7349],[1268265600000,7323],[1268352000000,7266],[1268611200000,7298],[1268697600000,7288],[1268784000000,7271],[1268870400000,7322],[1268956800000,7382],[1269216000000,7424],[1269302400000,7398],[1269388800000,7498],[1269475200000,7488],[1269561600000,749],[1269820800000,7424],[1269907200000,7418],[1269993600000,742],[1270080000000,7426],[1270166400000,7426],[1270425600000,7426],[1270512000000,7466],[1270598400000,7497],[1270684800000,7522],[1270771200000,7473],[1271030400000,7362],[1271116800000,7363],[1271203200000,7346],[1271289600000,7384],[1271376000000,7389],[1271635200000,7446],[1271721600000,7416],[1271808000000,7479],[1271894400000,7498],[1271980800000,7514],[1272240000000,7508],[1272326400000,7525],[1272412800000,7551],[1272499200000,7545],[1272585600000,7511],[1272844800000,7555],[1272931200000,7641],[1273017600000,7739],[1273104000000,7858],[1273190400000,7847],[1273449600000,7712],[1273536000000,7876],[1273622400000,7884],[1273708800000,7946],[1273795200000,8006],[1274054400000,8099],[1274140800000,8047],[1274227200000,8151],[1274313600000,8109],[1274400000000,8003],[1274659200000,8092],[1274745600000,8182],[1274832000000,8125],[1274918400000,8161],[1275004800000,8076],[1275264000000,8126],[1275350400000,8228],[1275436800000,8186],[1275523200000,8152],[1275609600000,8293],[1275868800000,8363],[1275955200000,8375],[1276041600000,8327],[1276128000000,8303],[1276214400000,8247],[1276473600000,8165],[1276560000000,8159]]

          let seriesData2 = [[1214265600000,5445],[1214352000000,6912],[1214438400000,6358],[1214524800000,635],[1214784000000,634],[1214870400000,634],[1214956800000,6328],[1215043200000,6296],[1215129600000,6382],[1215388800000,639],[1215475200000,636],[1215561600000,6364],[1215734400000,366],[1215993600000,6311],[1216080000000,6255],[1216166400000,6295],[1216252800000,611],[1216339200000,6324],[1216598400000,630],[1216684800000,623],[1216771200000,6354],[1216857600000,638],[1216944000000,6357],[1217203200000,632],[1217289600000,6368],[1217376000000,641],[1217462400000,647],[1217548800000,6422],[1217808000000,6425],[1217894400000,6458],[1217980800000,662],[1218067200000,6465],[1218153600000,665],[1218412800000,662],[1218499200000,6709],[1218585600000,6711],[1218672000000,6709],[1218758400000,69],[1219017600000,6802],[1219104000000,681],[1219190400000,675],[1219276800000,6751],[1219363200000,6754],[1219622400000,6773],[1219708800000,651],[1219795200000,6773],[1219881600000,671],[1219968000000,678],[1220227200000,684],[1220313600000,689],[1220400000000,6926],[1220486400000,690],[1220572800000,702],[1220832000000,703],[1220918400000,703],[1221004800000,7096],[1221091200000,7178],[1221177600000,711],[1221436800000,708],[1221523200000,701],[1221609600000,7031],[1221696000000,637],[1221782400000,25],[1222041600000,6864],[1222128000000,6789],[1222214400000,608],[1222300800000,6804],[1222387200000,6832],[1222646400000,69],[1222732800000,693],[1222819200000,7103],[1222905600000,7194],[1222992000000,72],[1223251200000,7336],[1223337600000,7337],[1223424000000,724],[1223510400000,71],[1223596800000,7365],[1223856000000,7333],[1223942400000,723],[1224028800000,734],[1224115200000,7405],[1224201600000,745],[1224460800000,75],[1224547200000,7586],[1224633600000,7787],[1224720000000,787],[1224806400000,794],[1225065600000,8027],[1225152000000,796],[1225238400000,732],[1225324800000,7673],[1225411200000,784],[1225670400000,78],[1225756800000,7801],[1225843200000,7771],[1225929600000,787],[1226016000000,78],[1226275200000,7758],[1226361600000,7846],[1226448000000,792],[1226534400000,7985],[1226620800000,7891],[1226880000000,793,[1226966400000,7904],[1227052800000,716],[1227139200000,7974],[1227225600000,793],[1227484800000,783],[1227571200000,7807],[1227657600000,7752],[1227744000000,773],[1227830400000,788],[1228089600000,7932],[1228176000000,777],[1228262400000,7923],[1228348800000,7925],[1228435200000,785],[1228694400000,771],[1228780800000,77],[1228867200000,7738],[1228953600000,756],[1229040000000,7497],[1229299200000,7403],[1229385600000,73056],[1229472000000,114],[1229558400000,843],[1229644800000,7175],[1229904000000,159],[1229990400000,7155],[1230076800000,7141],[1230163200000,7141],[1230249600000,741],[1230508800000,7009],[1230595200000,7094],[1230681600000,786],[1230768000000,7186],[1230854400000,7213],[1231113600000,7365],[1231200000000,702],[1231286400000,757],[1231372800000,7345],[1231459200000,709],[1231718400000,7467],[1231804800000,7541],[1231891200000,7595],[1231977600000,743],[1232064000000,737],[1232323200000,7587],[1232409600000,735],[1232496000000,7747],[1232582400000,7703],[1232668800000,7818],[1232928000000,799],[1233014400000,792],[1233100800000,7542],[1233187200000,728],[1233273600000,7804],[1233532800000,7838],[1233619200000,7984],[1233705600000,703],[1233792000000,796],[1233878400000,7816],[1234137600000,789],[1234224000000,7713],[1234310400000,773],[1234396800000,7293],[1234483200000,779],[1234742400000,78],[1234828800000,7916],[1234915200000,74],[1235001600000,7872],[1235088000000,7943],[1235347200000,7715],[1235433600000,786],[1235520000000,787],[1235606400000,7825],[1235692800000,71],[1235952000000,794],[1236038400000,7928],[1236124800000,7866],[1236211200000,796],[1236297600000,790],[1236556800000,796],[1236643200000,784],[1236729600000,7822],[1236816000000,7825],[1236902400000,785],[1237161600000,766],[1237248000000,772],[1237334400000,7617],[1237420800000,7316],[1237507200000,7382],[1237766400000,7377],[1237852800000,7805],[1237939200000,412],[1238025600000,35],[1238112000000,7523],[1238371200000,751],[1238457600000,7515],[1238544000000,755],[1238630400000,7468],[1238716800000,74],[1238976000000,741],[1239062400000,7545],[1239148800000,75],[1239235200000,7535],[1239321600000,7535],[1239580800000,7735],[1239667200000,753],[1239753600000,752],[1239840000000,7579],[1239926400000,759],[1240185600000,7713],[1240272000000,7734],[1240358400000,7525],[1240444800000,764],[1240531200000,7558],[1240790400000,762],[1240876800000,768],[1240963200000,7539],[1241049600000,7534],[1241136000000,7334],[1241395200000,754],[1241481600000,74],[1241568000000,7507],[1241654400000,784],[1241740800000,745],[1242000000000,7368],[1242086400000,7609],[1242172800000,732],[1242259200000,734],[1242345600000,7399],[1242604800000,712],[1242691200000,7347],[1242777600000,7306],[1242864000000,7233],[1242950400000,758],[1243209600000,739],[1243296000000,7191],[1243382400000,795],[1243468800000,7218],[1243555200000,7094],[1243814400000,7033],[1243900800000,724],[1243987200000,74],[1244073600000,7096],[1244160000000,705],[1244419200000,7213],[1244505600000,7165],[1244592000000,7092],[1244678400000,76],[1244764800000,7142],[1245024000000,7221],[1245110400000,72],[1245196800000,7226],[1245283200000,7185],[1245369600000,7179],[1245628800000,727],[1245715200000,715],[1245801600000,7129],[1245888000000,775],[1245974400000,7095],[1246233600000,7114],[1246320000000,7076],[1246406400000,795],[1246492800000,719],[1246579200000,7139],[1246838400000,797],[1246924800000,7134],[1247011200000,7195],[1247097600000,7149],[1247184000000,795],[1247443200000,757],[1247529600000,7148],[1247616000000,799],[1247702400000,7078],[1247788800000,7098],[1248048000000,7035],[1248134400000,732],[1248220800000,748],[1248307200000,7029],[1248393600000,73],[1248652800000,7009],[1248739200000,7029],[1248825600000,7091],[1248912000000,717],[1248998400000,704],[1249257600000,6993],[1249344000000,6953],[1249430400000,6941],[1249516800000,696],[1249603200000,6966],[1249862400000,742],[1249948800000,7],[1250035200000,7058],[1250121600000,697],[1250208000000,6997],[1250467200000,7107],[1250553600000,7093],[1250640000000,787],[1250726400000,722],[1250812800000,6979],[1251072000000,683],[1251158400000,6982],[1251244800000,7009],[1251331200000,701],[1251417600000,693],[1251676800000,708],[1251763200000,6987],[1251849600000,703],[1251936000000,6977],[1252022400000,7013],[1252281600000,6979],[1252368000000,61],[1252454400000,687],[1252540800000,6876],[1252627200000,683],[1252886400000,6869],[1252972800000,6845],[1253059200000,6817],[1253145600000,698],[1253232000000,601],[1253491200000,6823],[1253577600000,667],[1253664000000,6766],[1253750400000,6772],[1253836800000,6818],[1254096000000,627],[1254182400000,674],[1254268800000,683],[1254355200000,689],[1254441600000,688],[1254700800000,6843],[1254787200000,6794],[1254873600000,680],[1254960000000,677],[1255046400000,6781],[1255305600000,674],[1255392000000,6729],[1255478400000,6721],[1255564800000,6729],[1255651200000,626],[1255910400000,674],[1255996800000,6681],[1256083200000,703],[1256169600000,6668],[1256256000000,6659],[1256515200000,6659],[1256601600000,624],[1256688000000,675],[1256774400000,6763],[1256860800000,658],[1257120000000,6771],[1257206400000,6823],[1257292800000,6776],[1257379200000,627],[1257465600000,673],[1257724800000,6675],[1257811200000,668],[1257897600000,6651],[1257984000000,6703],[1258070400000,6727],[1258329600000,683],[1258416000000,674],[1258502400000,6687],[1258588800000,6729],[1258675200000,6751],[1258934400000,6682],[1259020800000,6681],[1259107200000,631],[1259193600000,636],[1259280000000,6704],[1259539200000,6657],[1259625600000,6635],[1259712000000,6628],[1259798400000,6615],[1259884800000,638],[1260144000000,664],[1260230400000,677],[1260316800000,6772],[1260403200000,679],[1260489600000,6777],[1260748800000,6828],[1260835200000,688],[1260921600000,686],[1261008000000,6973],[1261094400000,6976],[1261353600000,6961],[1261440000000,7004],[1261526400000,7006],[1261612800000,946],[1261699200000,646],[1261958400000,6943],[1262044800000,693],[1262131200000,6975],[1262217600000,6943],[1262304000000,6943],[1262563200000,651],[1262649600000,695],[1262736000000,697],[1262822400000,6992],[1262908800000,7007],[1263168000000,6884],[1263254400000,6907],[1263340800000,668],[1263427200000,694],[1263513600000,6958],[1263772800000,696],[1263859200000,7004],[1263945600000,7077],[1264032000000,7111],[1264118400000,776],[1264377600000,708],[1264464000000,7101],[1264550400000,7107],[1264636800000,7144],[1264723200000,7161],[1264982400000,7189],[1265068800000,176],[1265155200000,7152],[1265241600000,7223],[1265328000000,7305],[1265587200000,7314],[1265673600000,7268],[1265760000000,7279],[1265846400000,291],[1265932800000,769],[1266192000000,735],[1266278400000,7328],[1266364800000,7286],[1266451200000,7372],[1266537600000,7398],[1266796800000,74],[1266883200000,736],[1266969600000,7383],[1267056000000,7414],[1267142400000,737],[1267401600000,7395],[1267488000000,7382],[1267574400000,732],[1267660800000,737],[1267747200000,7364],[1268006400000,7321],[1268092800000,7377],[1268179200000,7349],[1268265600000,7323],[1268352000000,266],[1268611200000,798],[1268697600000,7288],[1268784000000,7271],[1268870400000,7322],[1268956800000,7382],[1269216000000,7424],[1269302400000,398],[1269388800000,798],[1269475200000,7488],[1269561600000,749],[1269820800000,7424],[1269907200000,7418],[1269993600000,742],[1270080000000,746],[1270166400000,7426],[1270425600000,7426],[1270512000000,7466],[1270598400000,7497],[1270684800000,7522],[1270771200000,7473],[1271030400000,362],[1271116800000,73],[1271203200000,7346],[1271289600000,7384],[1271376000000,7389],[1271635200000,7446],[1271721600000,7416],[1271808000000,479],[1271894400000,7498],[1271980800000,7514],[1272240000000,7508],[1272326400000,7525],[1272412800000,7551],[1272499200000,7545],[1272585600000,511],[1272844800000,755],[1272931200000,7641],[1273017600000,7739],[1273104000000,7858],[1273190400000,7847],[1273449600000,7712],[1273536000000,876],[1273622400000,784],[1273708800000,7946],[1273795200000,8006],[1274054400000,8099],[1274140800000,8047],[1274227200000,8151],[1274313600000,109],[1274400000000,803],[1274659200000,8092],[1274745600000,8182],[1274832000000,8125],[1274918400000,8161],[1275004800000,8076],[1275264000000,126],[1275350400000,828],[1275436800000,8186],[1275523200000,8152],[1275609600000,8293],[1275868800000,8363],[1275955200000,8375],[1276041600000,327],[1276128000000,803],[1276214400000,8247],[1276473600000,8165],[1276560000000,8159]]]
          // console.log(tempGraphObj)
          // console.log(isDataObj);
          
          
        //   8**************************************      for multiple series            **************

        //   for (const key in tempGraphObj) {
        //     if (tempGraphObj.hasOwnProperty(key)) {
        //       const element = tempGraphObj[key];
        //       // console.log(element , "element");
        //       // isDataObj = isDataObj ? true : (element.length ? true : false )
              
        //       seriesData.push({
        //         data: element,
        //         lineWidth: 1,
        //         marker: {
        //           symbol: 'circle'
        //         },
        //         yAxis: Number(key),
        //         name: SerieslabelName[key]
        //     })
        //     }
        //   }

          let title =  ""//data.statusCode == 103 ?  data.responseMessage : (!isDataObj ? "No Data Available" :assetChannelData.graphName)
          setTimeout(() => {


            (function(H) {
              H.wrap(H.Legend.prototype, 'positionCheckboxes', function(p, scrollOffset) {
                var alignAttr = this.group.alignAttr,
                  translateY,
                  clipHeight = this.clipHeight || this.legendHeight;
            
                if (alignAttr) {
                  translateY = alignAttr.translateY;
                  H.each(this.allItems, function(item) {
                    var checkbox = item.checkbox,
                      bBox = item.legendItem.getBBox(true),
                      top;
            
                    if (checkbox) {
                      top = (translateY + checkbox.y + (scrollOffset || 0) + 2);
                      H.css(checkbox, {
                        left: (alignAttr.translateX + item.checkboxOffset + checkbox.x - 80 - bBox.width) + 'px',
                        top: (top+4) + 'px',
                        display: top > translateY - 6 && top < translateY + clipHeight - 6 ? '' : 'none'
                      });
                    }
                  });
                }
              });
            })(Highcharts);



              let chartObj = Highcharts.chart('chart-container-runtime', {

                chart: {
                    zoomType: 'x',
                    type: 'spline'
                },
                // exporting: { enabled: false },
                title: {
                    text: title
                },
                time:{
                  useUTC:false,
                },
                // subtitle: {
                //     text: ''
                // },
                // noData: "no data available",
                tooltip: {
                    // valueDecimals: 2,
                    // crosshairs: true,
                    shared: true,
                    xDateFormat: '%Y-%m-%d',
                    
                },
                legend: {
                  enabled : true,
                  // itemDistance: 50,
                  
                  itemMarginTop: 4,
                  itemMarginBottom: 4,
                  // enabled: true,
                  // symbolPadding: 20
                //   useHTML: true,
                //   symbolWidth: 0,
                //   labelFormatter: function() {
                //     return '<input type="checkbox">' + series.name
                //   }
                },
                plotOptions:{
                  series:{
                    showCheckbox:true,
                    selected:true,
                    showInLegend: true,
                    events: {
                      legendItemClick: function() {
                        return false;
                      },
                      checkboxClick: function (event) {
                          if (event.checked) {
                              this.show();
                          } else {
                              this.hide();
                          }
                      }
                  }
                  }
                },


               /*  exporting: {
                  buttons: {
                      contextButton: {
                          // text: 'DOWNLOAD',
                          theme: {
                              fill: 'transparent',
                              //'stroke-width': 1,
                              //stroke: 'white',
                              //r: 1,
                              style: {
                                  color: 'white',
                                  fontSize: '10px'
                              },   
  
                              // states: {
                              //     hover: {
                              //         fill: 'transparent'
                              //     },
                              //     select: {
                              //         fill: 'transparent'
                              //     }
                              // }
                          },
                          menuItems: [{
                              text: 'Download PNG image',
                              onclick: function () {
                                  this.exportChart({
                                      type: 'image/png'
                                  });
                              }
                          }, {
                              text: 'Download JPEG image',
                              onclick: function () {
                                  this.exportChart({
                                      type: 'image/jpeg'
                                  });
                              }
                          }, {
                              text: 'Download PDF document',
                              onclick: function () {
                                  this.exportChart({
                                      type: 'application/pdf'
                                  });
                              }
  
                          }]
                      }
                  },
                  // filename: 'Map',
                  allowHTML: true,
                  chartOptions: {
                      chart: {
                          style: {
                              fontFamily: '"Gotham SSm A" "Gotham SSm B"'
                          },
                          height: 880,
                          spacingBottom: 300,
                          marginTop: 50,
                          width: 1010,
                          // backgroundColor: 'rgba(0, 0, 0, 0)',
  //                         events: {
  //                             load: function () {
  //                                 this.series[0].update({
  //                                     nullColor: 'rgba(245, 245, 245, 1)',
  //                                     borderColor: 'rgba(192, 192, 192, 1)'
  //                                 });
  //                                 //DisableGeographiesOnExport(this);
  //                                 //this.renderer.image('http://www.eiu.com/images/logos/EIU_logo2x.png', 0, 740, 100, 25).add();
  //                                 //this.renderer.image('http://data.eiu.com/assets/images/charts/bubbles-legend.png', 600, 565, 20, 16).add();
  //                                 this.renderer.label('<b>Size of opportunity</b>', 620, 565, null, null, null, true).add();
  //                                 //var label = this.renderer.label(getExportPropertiesTable(), null, null, null, null, null, true).add();
  
  // //                                label.align(Highcharts.extend(label.getBBox(), {
  // //                                    align: 'center',
  // //                                    x: 0, // offset
  // //                                    verticalAlign: 'bottom',
  // //                                    y: 160 // offset
  // //                                }), null, 'spacingBox');  
  //                             }
  //                         }
                      },
                      legend: {
                          enabled: true,
                          verticalAlign: 'bottom',
                          align: 'center',
                          itemMarginTop: -10,
                          // itemStyle: {
                          //     color: 'rgb(0,0,0)'
                          // },
                          symbolRadius: 6,
                          symbolHeight: 13,
                          symbolWidth: 13                                                
                      },
                      // credits: {
                      //     enabled: true,
                      //     text: 'Copyright ©2015 The Economist Intellligence Unit.  Output generated April 30th 2014 11:22 GMT+00:00',
                      //     position: {
                      //       align: 'left',
                      //       x: 110,
                      //       verticalAlign: 'bottom',
                      //       y: -115
                      //     }
                      // },
                      title: {
                          text: "Asset Graph",
                          style: {
                              fontWeight: 'bold'
                          }
                      }
                  }
              },   */  

                
                xAxis: {
                    type: 'datetime'
                },
                // yAxis: yAxisArray,

                // series: seriesData    // -----------for multiple series
                series:[{
                    // type: 'area',
                    name: 'Current Year',
                    data: seriesData
                },
                {
                    // type: 'area',
                    name: 'Previous Year',
                    data: seriesData2
                }]
            });


            // chartObj.exportChart()
          }, 200);


          /* ************************************Highchart end********************************************** */
    }

    // tier Select  function ---------
    updateTierOptions(tier, $event){

    }



}
